/**
 * styles.ts
 *
 * Author: Maurice T. Meyer
 * E-Mail: maurice@lavireo.com
 *
 * (c) Laviréo. All rights reserved.
 *
 * This document is the property of Laviréo.
 * It is considered confidential and proprietary.
 *
 * This document may not be reproduced or transmitted in any form,
 * in whole or in part, without the express written permission of
 * Laviréo.
 */

import { css } from '@emotion/react';

export const Styles = {
  button: css({
    textAlign:       'center',
    display:         'flex',
    gap:             4,
    justifyContent:  'center',
    alignItems:      'center',
    cursor:          'pointer',
    position:        'relative',
    borderRadius:    5,
    border:          'none',
    outline:         'none',
    fontWeight:      '400',
    fontSize:        '14px',
    lineHeight:      '24px'
  }),

  sizes: {
    small: css({
      padding: '8px 16px'
    }),
  
    normal: css({
      padding: '12px 24px'
    }),
  },

  types: {
    primary: css({
      color:           'rgb(255, 255, 255)',
      backgroundColor: 'rgb(224, 168, 55)',
  
      ':disabled': {
        color: 'rgba(232, 205, 152, 1)',
        backgroundColor: 'rgb(224, 168, 55)',
      }
    }),
  
    secondary: css({
      color:           'rgb(255, 255, 255)',
      backgroundColor: 'rgb(56, 59, 74)',
  
      ':disabled': {
        color: 'rgb(112, 112, 124)',
        backgroundColor: 'rgb(56, 59, 74)',
      }
    }),

    subtle: css({
      color: '#000',
      backgroundColor: 'transparent',
  
      ':hover': {
        backgroundColor: 'rgb(212, 212, 232)'
      },
  
      ':disabled': {
        backgroundColor: 'transparent'
      }
    })
  }
};
